import React from 'react';
import loadable from '@loadable/component';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

// NOTE: You could add the actual Terms of Service here as a fallback
//       instead of showing this error message.
const fallbackTerms = `
Welcome to Local Hire Marketplace. By accessing or using our platform, you agree to comply with and be bound by these Terms of Service.

## 1. User Responsibilities
Users must provide accurate information when listing items or booking hires. Equipment owners are responsible for maintaining equipment in safe operating condition.

## 2. Hires and Bookings
All hires are subject to availability and acceptance by the equipment owner. Renters must return equipment on time and in the condition received.

## 3. Cancellations and Refunds
Cancellations and refunds are governed by our platform cancellation policy as set out during booking confirmation.

## 4. Limitation of Liability
Local Hire Marketplace is a venue connecting equipment owners and hirers. Users agree to operate equipment safely and follow all manufacturer and safety instructions.
`;

// Create fallback content (array of sections) in page asset format:
export const fallbackSections = {
  sections: [
    {
      sectionType: 'article',
      sectionId: 'terms',
      appearance: { fieldType: 'customAppearance', backgroundColor: '#ffffff' },
      title: { fieldType: 'heading1', content: 'Terms of Service' },
      blocks: [
        {
          blockType: 'defaultBlock',
          blockId: 'hero-content',
          text: {
            fieldType: 'markdown',
            content: fallbackTerms,
          },
        },
      ],
    },
  ],
  meta: {
    pageTitle: {
      fieldType: 'metaTitle',
      content: 'Terms of service page',
    },
    pageDescription: {
      fieldType: 'metaDescription',
      content: 'Terms of service fetch failed',
    },
  },
};

// This is the fallback page, in case there's no Terms of Service asset defined in Console.
const FallbackPage = props => {
  return <PageBuilder pageAssetsData={fallbackSections} {...props} />;
};

export default FallbackPage;
